import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'app-candidate-profile-page',
  templateUrl: './candidateprofile-page.component.html'
})
export class CandidateProfilePageComponent implements OnInit {
  @Input() $transition$: any;

  candidateId: string;

  constructor(public $state: StateService) { }

  ngOnInit() {
    const stateParams = this.$transition$.params();
    this.candidateId = stateParams.candidateId;
  }
}
